import React, { useState, Fragment } from 'react';
import _ from 'lodash';

import '../OrgReport/index.css';
import '../Analyze.scss';

import { useSelector } from 'react-redux';
import reportIcon from '../../../../assets/images/relatorios-icon.svg';
import Header from '../../../../components/Header';
import Topic from './Components/Topic';
import { screenType } from './index';

/**
 * Main screen component, container for the entire screen on the reports
 *
 * @param {*} props
 * @returns
 */
const MainScreenReport = (props) => {
  const { topics, reportScreenType, currentPageInitialState, user } = props;
  const [currentPageState, setCurrentSPageState] = useState({
    ...currentPageInitialState,
    component: () => getInitialComponent(),
  });

  /**
   * Get the correct component for loading when the screen is render
   */
  const getInitialComponent = () => {
    const pageData = _.find(
      topics,
      (topic) => topic.page === currentPageInitialState.page
    );

    return pageData
      ? pageData.component(currentPageInitialState.subPage)
      : false;
  };

  /**
   * Render the topics components for this report
   */

  const renderTopics = (companyHasFreemiumPlan) => {
    const newTopics = _.map(topics, (topic) => {
      return (
        <Topic
          key={topic.page}
          currentPageState={currentPageState}
          setCurrentSPageState={setCurrentSPageState}
          data={topic}
        />
      );
    });

    return companyHasFreemiumPlan
      ? newTopics.filter((topic) => topic.key !== 'consumption')
      : newTopics;
  };

  /**
   * Render the Header component when needed
   */
  const renderHeader = () => {
    if (reportScreenType === screenType.ORG) {
      return <Header pagetype="page-inicio" />;
    }
  };

  /**
   * Render the report title when needed
   */
  const renderReportTitle = () => {
    if (reportScreenType === screenType.ORG) {
      return (
        <div className="report-title">
          <img src={reportIcon} alt="" />
          <p className="report-title-word">Relatórios</p>
        </div>
      );
    }
  };

  /**
   * Render the current component content if is released
   */
  const renderComponent = () => {
    const currentPageReleased = _.find(
      topics,
      (topic) => topic.page === currentPageInitialState.page
    );
    if (currentPageReleased.released) {
      return currentPageState.component(currentPageState.subPage);
    }
    return false;
  };

  const { company } = useSelector((state) => state.companies);

  const companyHasFreemiumPlan =
    company?.plan?.name && company?.plan?.name?.toLowerCase() === 'freemium';

  return (
    <Fragment>
      {renderHeader()}
      <div className="container-menu">
        <div
          className="container-analise-menu"
          style={{ marginLeft: 50, marginRight: 50 }}
        >
          {/* TODO: put the org report button for return to home screen */}
          <div className="analise-menu-alt">
            {renderReportTitle()}
            {renderTopics(companyHasFreemiumPlan)}
          </div>
        </div>
        <div className="container-menu-select">{renderComponent()}</div>
      </div>
    </Fragment>
  );
};

export default MainScreenReport;
